import { supabase } from '../lib/supabase';

export const fetchSanitationLogs = async (loadAll = false) => {
  let query = supabase.from('steril_logs').select('*').order('date', { ascending: false });
  if (!loadAll) query = query.limit(100);
  const { data } = await query;
  return data || [];
};

export const insertSanitationLog = async (payload) => {
  const { error } = await supabase.from('steril_logs').insert([payload]);
  if (error) throw error;
};

export const updateSanitationLog = async (id, payload) => {
  const { error } = await supabase.from('steril_logs').update(payload).eq('id', id);
  if (error) throw error;
};

export const deleteSanitationLog = async (id) => {
  const { error } = await supabase.from('steril_logs').delete().eq('id', id);
  if (error) throw error;
};
